import { render, staticRenderFns } from "./ColorsPanel.vue?vue&type=template&id=1ce75ad7"
import script from "./ColorsPanel.vue?vue&type=script&lang=js"
export * from "./ColorsPanel.vue?vue&type=script&lang=js"
import style0 from "./ColorsPanel.vue?vue&type=style&index=0&id=1ce75ad7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports